import { getFunctions, httpsCallable } from 'firebase/functions'

export const cloudFunction = async <T = any>(functionName: string, params?: any): Promise<T> => {
	const functions = getFunctions()
	const callable = httpsCallable(functions, functionName)
	const result = await callable(params)
	return result.data as T
}
